import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const herosectionData = {
  name: "Lutfi Riani",
  aboutMe:
    "A fresh graduate in Software Engineering from Institut Pertanian Bogor (IPB University) with a strong interest in Data Analytics and Web Development. Experienced in data processing, analysis, visualization, and reporting, as well as designing and developing web-based applications. I combine analytical and technical skills with a strong attention to detail to support business needs and deliver effective digital solutions.",
  roles: [
    "Software Engineer",
    "Data Analyst",
    "Web Developer",
    "Data Storyteller",
  ],
  chips: [
    "Data Analytics",
    "Web Development",
    "Data Visualization",
    "Reporting",
  ],
};

// Efek mengetik: teks role berganti otomatis
function useTypewriter(words, typingSpeed = 80, deleteSpeed = 40, pause = 1400) {
  const [index, setIndex] = useState(0);
  const [text, setText] = useState("");
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const current = words[index % words.length];
    let timeout;

    if (!deleting && text === current) {
      timeout = setTimeout(() => setDeleting(true), pause);
    } else if (deleting && text === "") {
      setDeleting(false);
      setIndex((i) => (i + 1) % words.length);
    } else {
      timeout = setTimeout(
        () =>
          setText(
            deleting
              ? current.slice(0, text.length - 1)
              : current.slice(0, text.length + 1)
          ),
        deleting ? deleteSpeed : typingSpeed
      );
    }
    return () => clearTimeout(timeout);
  }, [text, deleting, index, words, typingSpeed, deleteSpeed, pause]);

  return text;
}

function Herosection() {
  const role = useTypewriter(herosectionData.roles);

  return (
    <section className="hero hero-gradient shadow-dark d-flex align-items-center">
      <div className="overlay"></div>

      {/* Dekorasi latar */}
      <div className="hero-blob hero-blob--1" aria-hidden="true"></div>
      <div className="hero-blob hero-blob--2" aria-hidden="true"></div>
      <div className="hero-blob hero-blob--3" aria-hidden="true"></div>

      <div
        className="cta mx-auto"
        style={{ position: "relative", zIndex: 1, padding: "60px 0" }}
      >
        <span
          className="hero-badge hero-fade"
          style={{ "--d": "0s", display: "inline-flex" }}
        >
          <span className="hero-badge__dot"></span>
          Open to work
        </span>

        <h1 className="mt-0 mb-2 hero-fade" style={{ "--d": "0.1s" }}>
          I’m <span className="hero-name">{herosectionData.name}</span>
          <span className="dot"></span>
        </h1>

        <p className="hero-role mb-4 hero-fade" style={{ "--d": "0.2s" }}>
          <span className="hero-role__prefix">&gt;</span> {role}
          <span className="hero-caret"></span>
        </p>

        <div
          className="description-card mb-4 hero-fade"
          style={{ "--d": "0.3s" }}
        >
          <p>{herosectionData.aboutMe}</p>
        </div>

        <div
          className="hero-chips mb-4 hero-fade"
          style={{
            "--d": "0.4s",
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          {herosectionData.chips.map((chip) => (
            <span className="hero-chip" key={chip}>
              {chip}
            </span>
          ))}
        </div>

        <div className="hero-fade" style={{ "--d": "0.5s" }}>
          <Link to="/works" className="btn btn-default btn-lg mr-3 hero-btn">
            <i className="icon-grid"></i> View Portofolio
          </Link>

          <div
            className="spacer d-md-none d-lg-none d-sm-none"
            data-height="10"
          ></div>

          <Link to="/contact" className="btn btn-border-light btn-lg hero-btn">
            <i className="icon-envelope"></i> Hire me
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Herosection;